document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Product gallery (swipe carousel + dots) ---------- */
  var track = document.getElementById('ProductGalleryTrack');
  var dotsWrap = document.getElementById('ProductGalleryDots');
  var prevBtn = document.getElementById('ProductGalleryPrev');
  var nextBtn = document.getElementById('ProductGalleryNext');
  var slides = track
    ? Array.prototype.slice.call(track.querySelectorAll('.product__gallery-slide'))
    : [];

  // Visible slides, in the order they actually appear (flex `order` can promote one).
  function visibleSlides() {
    return slides
      .filter(function (s) { return !s.classList.contains('is-hidden'); })
      .sort(function (a, b) {
        return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0);
      });
  }

  function currentIndex() {
    if (!track || !track.clientWidth) return 0;
    return Math.round(track.scrollLeft / track.clientWidth);
  }

  function goTo(i, smooth) {
    var vs = visibleSlides();
    if (!track || !vs.length) return;
    var clamped = Math.max(0, Math.min(i, vs.length - 1));
    track.scrollTo({ left: clamped * track.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
    syncDots(clamped);
  }

  function syncDots(forced) {
    var total = visibleSlides().length;
    if (prevBtn) prevBtn.hidden = total < 2;
    if (nextBtn) nextBtn.hidden = total < 2;
    if (!dotsWrap) return;
    var i = typeof forced === 'number' ? forced : currentIndex();
    Array.prototype.slice.call(dotsWrap.children).forEach(function (d, n) {
      d.classList.toggle('is-active', n === i);
    });
  }

  function buildDots() {
    if (!dotsWrap) return;
    var total = visibleSlides().length;
    dotsWrap.innerHTML = '';
    if (total < 2) { syncDots(0); return; }
    for (var i = 0; i < total; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product__gallery-dot';
      b.setAttribute('aria-label', (i + 1) + '枚目');
      b.addEventListener('click', (function (n) {
        return function () { goTo(n, true); };
      })(i));
      dotsWrap.appendChild(b);
    }
    syncDots();
  }

  if (track) {
    track.addEventListener('scroll', function () { syncDots(); }, { passive: true });
    window.addEventListener('resize', function () { goTo(currentIndex(), false); });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1, true); });
    buildDots();
  }

  /* ---------- Variant selection ---------- */
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var data = { options: [], variants: [] };
  var dataEl = document.getElementById('ProductVariantData');
  if (dataEl) {
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  }
  var variants = data.variants || [];
  var optionDefs = data.options || [];
  if (!variants.length) return;

  var select = document.getElementById('ProductVariantSelect');
  var priceEl = document.getElementById('ProductPrice');
  var submit = document.getElementById('ProductSubmit');
  var submitText = document.getElementById('ProductSubmitText');
  var inputs = Array.prototype.slice.call(form.querySelectorAll('.product__option-input'));

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9ぁ-んァ-ヶ一-龥]/g, '');
  }

  // Each image's alt text, normalised — this is the "which variant is this photo for?" tag.
  var slideTags = slides.map(function (s) { return norm(s.getAttribute('data-alt')); });

  // An option only filters the gallery if at least one image is actually tagged with it.
  var tagVals = optionDefs.map(function (opt) {
    var vals = (opt.values || []).map(norm).filter(Boolean);
    var used = slideTags.some(function (tag) {
      return tag && vals.some(function (v) { return tag.indexOf(v) !== -1; });
    });
    return used ? vals : null;
  });

  /* ---------- "[20oz] ..." lines in the description: shown only for that choice ---------- */
  var valueOption = {};
  optionDefs.forEach(function (opt, oi) {
    (opt.values || []).forEach(function (v) { valueOption[norm(v)] = oi; });
  });

  var MARKER = /^\s*\[([^\]]+)\]\s*/;

  function stripMarker(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue.trim()) continue;
      node.nodeValue = node.nodeValue.replace(MARKER, '');
      return;
    }
  }

  var markerNodes = [];
  document.querySelectorAll('.product__summary, .product__accordion-body').forEach(function (root) {
    root.querySelectorAll('li, p, tr, h4, img').forEach(function (el) {
      var isImg = el.tagName === 'IMG';
      var raw = isImg ? (el.getAttribute('alt') || '') : (el.textContent || '');
      var m = raw.match(MARKER);
      if (!m) return;
      if (isImg) el.setAttribute('alt', raw.replace(MARKER, ''));
      else stripMarker(el);
      markerNodes.push({
        el: el,
        values: m[1].split(/[\/,、\s]+/).map(norm).filter(Boolean)
      });
    });
  });

  function updateMarkers(sel) {
    var chosen = sel.map(norm);
    markerNodes.forEach(function (n) {
      var show = n.values.every(function (v) {
        var oi = valueOption[v];
        return oi === undefined || chosen[oi] === v;
      });
      n.el.hidden = !show;
    });
  }

  function currentSelection() {
    var sel = [];
    inputs.forEach(function (input) {
      if (input.checked) sel[parseInt(input.getAttribute('data-position'), 10) - 1] = input.value;
    });
    return sel;
  }

  function matches(variant, sel) {
    return variant.options.every(function (value, i) {
      return sel[i] === undefined || value === sel[i];
    });
  }

  function updateLabels(sel) {
    form.querySelectorAll('.product__option-selected').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-selected-for'), 10) - 1;
      el.textContent = sel[i] || '';
    });
  }

  function updateAvailability(sel) {
    inputs.forEach(function (input) {
      var pos = parseInt(input.getAttribute('data-position'), 10) - 1;
      var test = sel.slice();
      test[pos] = input.value;
      var ok = variants.some(function (v) { return v.available && matches(v, test); });
      var pill = input.parentNode;
      if (pill) pill.classList.toggle('is-unavailable', !ok);
    });
  }

  function showAllSlides() {
    slides.forEach(function (s) { s.classList.remove('is-hidden'); });
  }

  // Keep a photo when, for every option that is used as a tag somewhere,
  // the photo either carries the chosen value or mentions no value of that
  // option at all (= a shared photo). Nothing tagged -> show everything.
  function filterSlides(sel, variant) {
    if (!slides.length) return;
    if (!tagVals.some(Boolean)) { showAllSlides(); return; }

    var kept = slides.filter(function (s, i) {
      var tag = slideTags[i];
      return tagVals.every(function (vals, oi) {
        if (!vals) return true;
        var chosen = norm(sel[oi]);
        if (!chosen) return true;
        var mentionsAny = vals.some(function (v) { return tag.indexOf(v) !== -1; });
        return !mentionsAny || tag.indexOf(chosen) !== -1;
      });
    });

    if (!kept.length) { showAllSlides(); return; }

    slides.forEach(function (s) {
      var keep = kept.indexOf(s) !== -1 ||
                 (variant && variant.image && s.getAttribute('data-full') === variant.image);
      s.classList.toggle('is-hidden', !keep);
    });
  }

  // Put the chosen variant's own photo first, so the gallery always opens on it
  // and you swipe forwards from there.
  function promoteVariantSlide(variant) {
    slides.forEach(function (s) { s.style.order = ''; });
    if (!variant || !variant.image) return;
    slides.forEach(function (s) {
      if (s.getAttribute('data-full') === variant.image) s.style.order = '-1';
    });
  }

  function update() {
    var sel = currentSelection();
    updateLabels(sel);
    updateAvailability(sel);
    updateMarkers(sel);

    var variant = variants.filter(function (v) { return matches(v, sel); })[0];

    filterSlides(sel, variant);
    promoteVariantSlide(variant);
    buildDots();
    goTo(0, false);

    if (!variant) return;

    if (select) select.value = variant.id;

    if (priceEl) {
      priceEl.innerHTML = variant.comparePrice
        ? '<span class="product__price--sale">' + variant.price + '</span>' +
          '<span class="product__price--compare">' + variant.comparePrice + '</span>'
        : variant.price;
    }

    if (submit) submit.disabled = !variant.available;
    if (submitText) submitText.textContent = variant.available ? 'カートに追加' : '在庫切れ';

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  inputs.forEach(function (input) {
    input.addEventListener('change', update);
  });

  update();
});